import { Avatar, Button, Flex, Modal } from "@mantine/core";
import styled from "styled-components";

const AreYouSureModal = ({
  opened,
  setOpened,
  proccessFunc,
  title,
  text,
  cancelButtonText,
  confirmButtonText,
}: any) => {
  return (
    <Modal
      radius={"20px"}
      opened={opened}
      centered
      onClose={() => {
        setOpened(false);
      }}
    >
      <ModalContainer>
        <IconWrapper>
          <Avatar src={"/assets/redInfoCircle.png"} size={48} radius={0} />
        </IconWrapper>
        <Flex direction={"column"} gap={"12px"}>
          <ModalTitle>{title}</ModalTitle>
          <ModalText>{text}</ModalText>
        </Flex>
        <Flex justify={"center"} gap={"10px"}>
          <CancelButton unstyled onClick={() => setOpened(false)}>
            <CancelButtonLabel>{cancelButtonText}</CancelButtonLabel>
          </CancelButton>
          <ConfirmButton
            unstyled
            onClick={() => {
              proccessFunc();
              setOpened(false);
            }}
          >
            <ConfirmButtonLabel>{confirmButtonText}</ConfirmButtonLabel>
          </ConfirmButton>
        </Flex>
      </ModalContainer>
    </Modal>
  );
};
export default AreYouSureModal;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 20px 0px;
  gap: 40px;
`;

const IconWrapper = styled.div`
  align-self: center;
  width: max-content;
  padding: 15px;
  border-radius: 50%;
  background-color: #ffe8e9;
`;

const CancelButton = styled(Button)<any>`
  width: 154px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid black;
  gap: 4px;
  background-color: transparent;
  color: black;
  cursor: pointer;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
`;

const CancelButtonLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
`;

const ConfirmButton = styled(Button)<any>`
  width: 154px;
  height: 44px;
  border-radius: 10px;
  gap: 12px;
  padding: 11px 20px 11px 20px;
  background-color: #ee4549;
  cursor: pointer;
  border: none;
`;

const ConfirmButtonLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  color: white;
`;

const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: black;
`;
const ModalText = styled.div`
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #828282;
  line-height: 20px;
`;
